// TODO: reconsider the name and location of this component
import React, { useEffect } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import QuickSearch from '@Pages/QuickSearch/QuickSearch';
import isUndefined from 'lodash/isUndefined';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import Dev from '@Pages/Dev';
import History from '@Pages/History';
import Alerts from '@Pages/Alerts';
import RetroSynthesis from '@Pages/RetroSynthesis/RetroSynthesisRoot';
import QueryBuilder from '@Pages/QueryBuilder/QueryContainer';
import ProfileSettings from '@Pages/ProfileSettings';
import StructureEditor from '@Pages/StructureEditor/StructureEditorPageContainer';
import Hopinto from '@Pages/Hopinto';
import HeaderComponentContainer from '@Containers/Header/HeaderComponentContainer';
import ChemQuoteExportTabContainer from '@Containers/ExportTab/ChemQuoteExportTabContainer';
import ExportTabContainer from '@Containers/ExportTab/ExportTabContainer';
import MessageBroker from '@Services/MessageBroker';
import UserInterfaceConfig from '@Services/UserInterfaceConfig';
import RxSocket from '@Services/RxSocket';
import AppStorage from '@Services/AppStorage';
import UserDatabases from '@Services/UserDatabases';
import Heartbeat from '@Services/Heartbeat';
import ExportResource from '@Services/ExportResource';
import IdleHandling from '@Services/IdleHandling';
import { RxSocketUrls } from '@Constants/CommonConstants';
import ResultsInterface from '@Services/ResultsInterface';
import SocketBroker from '@Services/SocketBroker';
import Auth from '@Services/Auth';
import AuthInterceptor from '@Services/AuthInterceptor';
import HeatmapPage from '@Pages/Heatmap/HeatmapContainer';
import Results from '@Pages/Results/ResultsContainer';
import { dispatchCreateAlert } from '@Pages/Alerts/AlertsComponents/AlertCreateDialog/AlertCreateDialogActions';
import { paths } from '../AppRoutes/constants';
import ConnectedRoute from '../AppRoutes/ConnectedRoute';

function Main() {
  function isValidDB(scheduledItem) {
    if (scheduledItem.databaseId) {
      return (
        UserDatabases.getListWithIds().indexOf(scheduledItem.databaseId) >= 0 &&
        find(UserDatabases.getUserSearchContexts(), { serverAlias: scheduledItem.context })
      );
    }
    if (isEmpty(scheduledItem.databases)) {
      return find(UserDatabases.getUserSearchContexts(), { serverAlias: scheduledItem.context });
    }
    return true;
  }
  useEffect(() => {
    RxSocket.connect();
    const unsubscriber = SocketBroker.observe(RxSocketUrls.ChannelsUrls.QueueErrors, (data) => {
      // websocket exception handler
      // ignore WS errors if in the process of logging out
      if (!Auth.isCurrentlyLoggingOut() && !isUndefined(data) && !isUndefined(data.exception)) {
        AuthInterceptor.responseError({ status: data.exception.statusCode, data: data.exception }, data.info);

        // moved to async call, to allow other RxJS observers to run
        setTimeout(() => {
          throw new Error(
            `[WebSocket/${data.exception.level}` +
              `/code:${data.exception.errorNumber}/status:${data.exception.statusCode}] ${data.exception.message} on ${data.exception.timestamp}`
          );
        });
      }
    });
    ResultsInterface.init();
    ExportResource.init();
    Heartbeat.start();
    IdleHandling.start();

    const isAnonymousUser = Auth.isAnonymousUser();
    const scheduledAlert = AppStorage.instance.get('scheduledAlert');
    const scheduledHistory = AppStorage.instance.get('scheduledHistory');

    if (scheduledAlert && isValidDB(scheduledAlert) && !isAnonymousUser) {
      dispatchCreateAlert(scheduledAlert);
    }
    AppStorage.instance.set('scheduledAlert', null);

    if (scheduledHistory && isValidDB(scheduledHistory)) {
      History.openSaveHistoryModal(scheduledHistory);
    } else {
      AppStorage.instance.set('scheduledHistory', null);
    }
    UserInterfaceConfig.initOnResize();
    return () => {
      ResultsInterface.destroy();
      Heartbeat.stop();
      unsubscriber();
      RxSocket.disconnect();
      IdleHandling.stop();
      MessageBroker.cancelAll();
      UserInterfaceConfig.resetOnResize();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <HeaderComponentContainer type="main" />
      <div className="main-wrapper">
        <Switch>
          <ConnectedRoute exact path={paths.SEARCH} key={paths.SEARCH} component={QuickSearch} />
          <ConnectedRoute exact path={paths.PREVIEW} key={paths.PREVIEW} component={QuickSearch} />
          <ConnectedRoute exact path={paths.DEV} component={Dev} />
          <ConnectedRoute exact path={paths.ADVANCED} component={QueryBuilder} />
          <ConnectedRoute exact path={paths.HISTORY_RECENT} component={History} />
          <ConnectedRoute exact path={paths.HISTORY_SAVED} component={History} />
          <ConnectedRoute exact path={paths.ALERTS} component={Alerts} />
          <ConnectedRoute exact path={paths.RESULTS} component={Results} />
          <ConnectedRoute exact path={paths.HEATMAP} component={HeatmapPage} />
          <ConnectedRoute exact path={paths.STRUCTURE_EDITOR} component={StructureEditor} />
          <ConnectedRoute path={`${paths.RS}/:path*`} component={RetroSynthesis} />
          <ConnectedRoute path={paths.PROFILE} component={ProfileSettings} />
          <ConnectedRoute exact path={paths.HOP_INTO} component={Hopinto} />
          <ConnectedRoute path="*" render={() => <Redirect to={paths.SEARCH} replace />} />
        </Switch>
      </div>
      <div className="export-tabs-wrapper">
        <ChemQuoteExportTabContainer />
        <ExportTabContainer />
      </div>
    </>
  );
}
export default Main;
